export default __webpack_public_path__ + "guide--raster-rasters-emspectrum-480-60b13f006be8959ef754da17a9e5b47f.png";